module.exports = __webpack_public_path__ + "static/media/BlueArrowUp.6c7e40ac.svg";